// Horizon UI Card base style: frosted glassmorphism in both modes, tuned for the
// silvery-graphite dark atmosphere (translucent surface + blur + edge highlight).
import { mode } from '@chakra-ui/theme-tools';

const Card = {
  baseStyle: (props) => ({
    p: '20px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    borderRadius: '16px',
    minWidth: '0px',
    wordWrap: 'break-word',
    bg: mode('rgba(255, 255, 255, 0.55)', 'rgba(255, 255, 255, 0.045)')(props),
    backdropFilter: 'blur(18px) saturate(140%)',
    WebkitBackdropFilter: 'blur(18px) saturate(140%)',
    border: '1px solid',
    borderColor: mode('rgba(255, 255, 255, 0.6)', 'rgba(226, 232, 240, 0.10)')(props),
    boxShadow: mode(
      '0 8px 32px rgba(112, 144, 176, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.7)',
      '0 12px 40px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.07)'
    )(props),
    backgroundClip: 'border-box'
  })
};

export const CardComponent = {
  components: {
    Card
  }
};
